import React from 'react';

function NumberFormat( data ) {

    const number = ()=>{
        switch ( data.type ) {
            case 'currency':
                let currencyConverter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                });
    
                return currencyConverter.format( data.amount )
            break;
    
            case 'number':
                return data.amount.toLocaleString()
            break;
        }
    }
    
  return (
    number()
  );
}

export default NumberFormat